import { Bookmarks } from '@phosphor-icons/react';

export default Bookmarks;
